import { APIDataProvider, TApiResponse } from './ApiDataProvider';
import { ApiPaths } from './APIPaths';

const apiDataProvider = new APIDataProvider();

export interface ChatAgentRequest {
  message: string;
}

export interface ChatAgentResponse {
  reply: string;
}

export const sendChatMessage = async (
  data: ChatAgentRequest
): Promise<ChatAgentResponse> => {
  const response = await apiDataProvider.post<TApiResponse<ChatAgentResponse>>(
    `${ApiPaths.gpt}/chat`,
    data
  );

  return response.data;
};
